<template>
  <div id="workflows-page">
    <h2 class="intro-y text-lg font-medium mt-10">
        用量檢查
    </h2>

    <div v-if="checkPermission(permissions, 'system.site.view') || checkPermission(permissions, 'site.media-library.manage')">
      <ul class="nav nav-tabs mt-5" role="tablist">
        <template v-for="(item, key) in usageTypes">
          <li v-if="checkPermission(permissions, item.permissions)" :key="key" :id="`usage-${key}-tab`" class="nav-item flex-1"
            role="presentation">
            <button class="nav-link w-full py-2" :class="{'active': currentType === item.type}" type="button" @click="changeType(item)"> {{ item.name }}
            </button>
          </li>
        </template>
      </ul>

      <div v-if="checkPermission(permissions, 'system.site.view')" v-show="currentType === 'overview'" class="tab-content border-l border-r border-b mb-5">
        <div class="tab-pane leading-relaxed p-5 active">
          <div v-show="loading" class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0 flex justify-end">
            <span><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
          <div v-if="!loading">
            <h5 class="intro-y text-lg font-medium">各分站用量</h5>
            <div class="overflow-x-auto mt-6">
                <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="whitespace-nowrap" width="10%">ID</th>
                        <th class="whitespace-nowrap" width="50%">名稱</th>
                        <th class="whitespace-nowrap" width="20%"><order-button title="檔案數量" column="file_count" :order-by.sync="systemUsageDataSitesOrderBy" :order.sync="systemUsageDataSitesOrder" default-order="desc"></order-button></th>
                        <th class="whitespace-nowrap" width="20%"><order-button title="總容量" column="total_size" :order-by.sync="systemUsageDataSitesOrderBy" :order.sync="systemUsageDataSitesOrder" default-order="desc"></order-button></th>
                    </tr>
                </thead>
                    <tbody>
                    <tr class="" v-for="(item, key) in systemUsageData.sites" :key="key">
                        <td>{{ item.site_id }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.file_count }}</td>
                        <td>{{ getFileSize(item.total_size) }}</td>
                    </tr>
                </tbody>
                </table>
            </div>
            <h5 class="intro-y text-lg font-medium mt-10">最高用量的用戶</h5>
            <div class="overflow-x-auto mt-6">
                <table class="table table-striped">
                  <colgroup>
                    <col width="20%">
                    <col width="35%">
                    <col width="15%">
                    <col width="15%">
                    <col width="15%">
                  </colgroup>
                <thead>
                    <tr>
                    <th class="whitespace-nowrap">名稱</th>
                    <th class="whitespace-nowrap">顯示名稱</th>
                    <th class="whitespace-nowrap">職員編號</th>
                    <th class="whitespace-nowrap"><order-button title="檔案數量" column="file_count" :order-by.sync="systemUsageDataTopUploadersOrderBy" :order.sync="systemUsageDataTopUploadersOrder" default-order="desc"></order-button></th>
                    <th class="whitespace-nowrap"><order-button title="總容量" column="total_size" :order-by.sync="systemUsageDataTopUploadersOrderBy" :order.sync="systemUsageDataTopUploadersOrder" default-order="desc"></order-button></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="" v-for="(item, key) in systemUsageData.top_uploaders" :key="key">
                    <td>{{ item.full_name ?? '-' }}</td>
                    <td>{{ item.display_name }}</td>
                    <td>{{ item.staff_number }}</td>
                    <td>{{ item.file_count }}</td>
                    <td>{{ getFileSize(item.total_size) }}</td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
        </div>
      </div>
      <div v-if="checkPermission(permissions, 'site.media-library.manage')" v-show="currentType === 'site'" class="tab-content border-l border-r border-b mb-5">
        <div class="tab-pane leading-relaxed p-5 active">
          <div v-show="loading" class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0 flex justify-end">
            <span><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
          <div v-if="!loading">
            <div class="overflow-x-auto mt-6">
              <h5 class="intro-y text-lg font-medium">最高用量的用戶</h5>
              <div class="overflow-x-auto mt-6">
                <table class="table table-striped">
                  <colgroup>
                    <col width="20%">
                    <col width="35%">
                    <col width="15%">
                    <col width="15%">
                    <col width="15%">
                  </colgroup>
                <thead>
                    <tr>
                    <th class="whitespace-nowrap">名稱</th>
                    <th class="whitespace-nowrap">顯示名稱</th>
                    <th class="whitespace-nowrap">職員編號</th>
                    <th class="whitespace-nowrap"><order-button title="檔案數量" column="file_count" :order-by.sync="siteUsageDataTopUploadersOrderBy" :order.sync="siteUsageDataTopUploadersOrder" default-order="desc"></order-button></th>
                    <th class="whitespace-nowrap"><order-button title="總容量" column="total_size" :order-by.sync="siteUsageDataTopUploadersOrderBy" :order.sync="siteUsageDataTopUploadersOrder" default-order="desc"></order-button></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="" v-for="(item, key) in siteUsageData.top_uploaders" :key="key">
                    <td>{{ item.full_name ?? '-' }}</td>
                    <td>{{ item.display_name }}</td>
                    <td>{{ item.staff_number }}</td>
                    <td>{{ item.file_count }}</td>
                    <td>{{ getFileSize(item.total_size) }}</td>
                    </tr>
                </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'permissions', 'currentSite', 'profile'],
  data() {
    return {
      mounted: false,
      loading: 0,

      usageTypes: [
        {
          type: 'overview',
          name: '總覽',
          permissions: ['system.site.view']
        },
        {
          type: 'site',
          name: '本分站用量',
          permissions: ['site.media-library.manage']
        }
      ],
      currentType: null,

      systemUsageData: [],
      systemUsageDataSitesOrderBy: 'total_size',
      systemUsageDataSitesOrder: 'DESC',
      systemUsageDataTopUploadersOrderBy: 'total_size',
      systemUsageDataTopUploadersOrder: 'DESC',

      siteUsageData: [],
      siteUsageDataTopUploadersOrderBy: 'total_size',
      siteUsageDataTopUploadersOrder: 'DESC'
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite(val) {
      if (val) {
        this.init()
      }
    },
    permissions(val) {
      if (val) {
        this.init()
      }
    },
    currentType(val) {
      if (this.mounted) {
        this.loadData()
      }
    },
    systemUsageDataSitesOrderBy(val) {
      this.loadUsageData()
    },
    systemUsageDataSitesOrder(val) {
      this.loadUsageData()
    },
    systemUsageDataTopUploadersOrderBy(val) {
      this.loadUsageData()
    },
    systemUsageDataTopUploadersOrder(val) {
      this.loadUsageData()
    },
    siteUsageDataTopUploadersOrderBy(val) {
      this.loadSiteUsageData()
    },
    siteUsageDataTopUploadersOrder(val) {
      this.loadSiteUsageData()
    }
  },
  async mounted() {
    window.tailwind.svgLoader()

    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.currentSite && this.permissions) {
        this.currentType = this.$route.query.type ?? (this.usageTypes.find(item => this.checkPermission(this.permissions, item.permissions))?.type ?? this.usageTypes[0].type)
        await this.loadData()

        this.mounted = true
      }
    },
    changeType(item) {
      if (this.currentType !== item.type) {
        this.currentType = item.type
      }
    },
    async loadData() {
      if (this.currentType === 'overview' && this.checkPermission(this.permissions, 'system.site.view')) {
        await this.loadUsageData()
      } else if (this.currentType === 'site' && this.checkPermission(this.permissions, 'site.media-library.manage')) {
        await this.loadSiteUsageData()
      }
    },
    async loadUsageData() {
      this.loading++

      const response = await this.getSiteLibraryUsage(50)

      if (response.code === 0) {
        this.systemUsageData = response.data
        if (this.systemUsageDataSitesOrderBy !== '' && this.systemUsageDataSitesOrder !== '') {
          this.systemUsageData.sites = this.systemUsageData.sites.sort((a, b) => {
            if (this.systemUsageDataSitesOrder === 'ASC') {
              return a[this.systemUsageDataSitesOrderBy] - b[this.systemUsageDataSitesOrderBy]
            } else {
              return b[this.systemUsageDataSitesOrderBy] - a[this.systemUsageDataSitesOrderBy]
            }
          })
        }
        if (this.systemUsageDataTopUploadersOrderBy !== '' && this.systemUsageDataTopUploadersOrder !== '') {
          this.systemUsageData.top_uploaders = this.systemUsageData.top_uploaders.sort((a, b) => {
            if (this.systemUsageDataTopUploadersOrder === 'ASC') {
              return a[this.systemUsageDataTopUploadersOrderBy] - b[this.systemUsageDataTopUploadersOrderBy]
            } else {
              return b[this.systemUsageDataTopUploadersOrderBy] - a[this.systemUsageDataTopUploadersOrderBy]
            }
          })
        }
      }

      this.loading--
    },
    async loadSiteUsageData() {
      this.loading++

      const response = await this.getSiteStatLibraryUsage(this.currentSite.site_id, 50)

      if (response.code === 0) {
        this.siteUsageData = response.data
        if (this.siteUsageDataTopUploadersOrderBy !== '' && this.siteUsageDataTopUploadersOrder !== '') {
          this.siteUsageData.top_uploaders = this.siteUsageData.top_uploaders.sort((a, b) => {
            if (this.siteUsageDataTopUploadersOrder === 'ASC') {
              return a[this.siteUsageDataTopUploadersOrderBy] - b[this.siteUsageDataTopUploadersOrderBy]
            } else {
              return b[this.siteUsageDataTopUploadersOrderBy] - a[this.siteUsageDataTopUploadersOrderBy]
            }
          })
        }
      }

      this.loading--
    }
  }
}
</script>

<style lang="scss" scoped>
#workflows-page {
  .tab-content {
    background-color: #FFF;

    table {
      thead {
        th:first-child, th:nth-child(3) {
          width: 120px;
        }
      }

      .table-report__action {
        width: 200px;
      }
    }
  }
}
</style>
